import './NewsletterSubscribePage.scss';

import { b2x } from '@b2x/react/src';

import { Container } from '../Container';
import { NewsletterPageContentType } from '../contentTypes';
import { NewsletterForm } from '../forms/NewsletterForm';
import { Page } from './Page';

export interface NewsletterSubscribePageProps {}

export const NewsletterSubscribePage = () => {
  const content = b2x.useContent<NewsletterPageContentType>('NEWSLETTER_PAGE_CONTENT_NEW');

  return (
    <Page
      background="primary"
      backgroundAsset={content?.body.asset}
      backgroundSize="cover"
      className="newsletter-subscribe-page"
      noPaddingBottom
    >
      <div className="page-content w-100 position-relative py-5 px-4 px-xl-0" style={{ zIndex: 20 }}>
        <Container>
          <b2x.Row className="justify-content-md-end justify-content-center px-sm-5 px-0">
            <b2x.Col className="newsletter-col text-white p-5" size={{ lg: 8, xl: 5, xs: 12 }}>
              <div className="text-start">
                {content?.body.title && <h1 className="h1 fw-semi-bold">{b2x.formatHtml(content.body.title)}</h1>}
                {content?.body.subTitle && (
                  <h5 className="mt-3 newsletter-subscribe-page-subtitle">{b2x.formatHtml(content.body.subTitle)}</h5>
                )}
              </div>
              <div className="form-container mt-4">
                <NewsletterForm source="website-section" />
              </div>
            </b2x.Col>
          </b2x.Row>
        </Container>
      </div>
    </Page>
  );
};
